import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Image } from "grommet";
import React from "react";
import { usePermission } from "../account/AccountStore";
import CustomButton from "../components/CustomButton";
import SkeletonWrapper from "../components/SkeletonWrapper";
import StyledModal from "../components/StyledModel";
import AllowedEntityTypesSelector from "./AllowedEntityTypesSelector";
import AllowedImageTypesSelector from "./AllowedImageTypesSelector";
import { ContentCard } from "./ContentCard";
import { ContentViewModel, DeleteContent, EntityTypes, ImageTypes, ListContent } from "./ContentStore";
import ContentCreate from "./CreateContent";

export const newContentIcon = (
    <span className="fa-layers fa-fw">
        {/* @ts-ignore */}
        <FontAwesomeIcon size="lg" icon={["fad", "image"]}></FontAwesomeIcon>
        <FontAwesomeIcon icon={["fad", "plus"]} swapOpacity transform="up-15 right-15" />
    </span>
);
const ContentManagement = () => {
    const [loading, setLoading] = React.useState(true);

    const [allowedTypes, setAllowedTypes] = React.useState(ImageTypes.All as ImageTypes);
    const [allowedEntities, setAllowedEntities] = React.useState(EntityTypes.All as EntityTypes);

    const [content, setContent] = React.useState([] as ContentViewModel[]);
    const [showCreateContentModal, setShowCreateContentModal] = React.useState(false);
    const [showContentModal, setShowContentModal] = React.useState(false);

    const listContent = () => {
        setLoading(true);
        ListContent(allowedTypes, allowedEntities, 0, 50)
            .then((res) => {
                setContent(res.result);
                setLoading(false);
            })
            .catch(() => {
                setContent([]);
                setLoading(false);
            });
    };

    React.useEffect(() => {
        listContent();
    }, [allowedTypes, allowedEntities]);

    const hasWritePermission = usePermission("sport:content.write");

    const [selectedContent, setSelectedContent] = React.useState({} as ContentViewModel);

    const startShowContent = (contentItem) => {
        setSelectedContent(contentItem);
        setShowContentModal(true);
    };

    const deleteSelectedContent = () => {
        DeleteContent(selectedContent.id).then(() => {
            setShowContentModal(false);
            listContent();
        });
    };

    return (
        <Box pad={{ vertical: "small" }}>
            {hasWritePermission && (
                <Box direction="row" gap="small">
                    {hasWritePermission && <CustomButton onClick={() => setShowCreateContentModal(true)} icon={newContentIcon} label="New Content"></CustomButton>}
                    <AllowedImageTypesSelector imageType={allowedTypes} onChange={setAllowedTypes} direction="row" border="small" round="5px" pad={{ horizontal: "small" }}></AllowedImageTypesSelector>
                    <AllowedEntityTypesSelector entityType={allowedEntities} onChange={setAllowedEntities} direction="row" border="small" round="5px" pad={{ horizontal: "small" }}></AllowedEntityTypesSelector>
                </Box>
            )}
            <SkeletonWrapper loading={loading}>
                <Box direction="row" gap="small" wrap>
                    {content.map((c) => (
                        <ContentCard key={c.id} content={c} onClick={() => startShowContent(c)} />
                    ))}
                </Box>
            </SkeletonWrapper>
            <StyledModal isOpen={showCreateContentModal}>
                <ContentCreate
                    onCreated={() => {
                        listContent();
                        setShowCreateContentModal(false);
                    }}
                ></ContentCreate>
                <Box direction="row">
                    <Button label="Close" onClick={() => setShowCreateContentModal(false)}></Button>
                </Box>
            </StyledModal>

            <StyledModal isOpen={showContentModal} setIsOpen={setShowContentModal}>
                <Image src={selectedContent.imageURI} width="100%" fit="contain" style={{ maxWidth: "400px" }} />
                <Button primary color="status-critical" label="Delete" onClick={deleteSelectedContent}></Button>
            </StyledModal>
        </Box>
    );
};

export default ContentManagement;
